import React from "react";
import { useInjection } from "../../di/DependencyContext";
import { AuthenticationService } from "../../modules/authentication/authentication.service";
import { DependencyType } from "../../di/DependencyType";
import { normalizeTokenQueryParam } from "@modules/authentication/tokenNormalization";

const AuthenticateMobile = () => {
  const [, setSuccess] = React.useState(false);
  const [, setError] = React.useState(false);
  const params = new URLSearchParams(window.location.search);
  const token = normalizeTokenQueryParam(params.get("token"));
  const requestId = params.get("requestId");
  const [loading, setLoading] = React.useState(true);
  const authenticationService = useInjection<AuthenticationService>(
    DependencyType.AuthenticationService
  );

  React.useEffect(() => {
    if (typeof token !== "string" || typeof requestId !== "string") {
      return;
    }

    authenticationService
      .verifyMobileAuthRequest(token, requestId)
      .then((res) => {
        setSuccess(res);
      })
      .catch(() => {
        setSuccess(false);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (typeof token !== "string") {
    return <div>Bad token</div>;
  }

  if (typeof requestId !== "string") {
    return <div>Bad requestId</div>;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      Authentication successful. You may now close this window and return to the
      ScentsCheck app.
    </>
  );
};

export default AuthenticateMobile;
